// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-data-table.disabled{opacity:.5;pointer-events:none}th span{text-transform:capitalize}.subData,th span{white-space:nowrap}.subData{color:#929292;font-size:12px!important}.capitalize{text-transform:capitalize}.v-data-table>.v-data-table__wrapper>.v-data-table__overflow{overflow-x:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
